import { createSlice } from "@reduxjs/toolkit";
import { AppDispatch } from "configureStore";

interface UserAssetsState {
  refreshNonce: number;
}

const initialState: UserAssetsState = {
  refreshNonce: 0,
};

const AssetsSlice = createSlice({
  name: "user-assets",
  initialState,
  reducers: {
    setDestroy() {
      return initialState;
    },
    requestUserAssetsRefresh(state: UserAssetsState) {
      state.refreshNonce += 1;
    },
  },
});

const { actions, reducer } = AssetsSlice;

export const { setDestroy, requestUserAssetsRefresh } = actions;
export default reducer;

/** Backward-compatible alias used after sign / assign flows. */
export const fetchUserAssets =
  (_companyId?: string) => (dispatch: AppDispatch) => {
    dispatch(requestUserAssetsRefresh());
  };
